import { Instagram, Facebook, Youtube, MapPin, Mail, Handshake, Wrench } from "lucide-react";
import { Link } from "react-router-dom";
import { useData } from "@/context/DataContext";
import { NewsletterSignup } from "@/components/newsletter/NewsletterSignup";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/wbdnhihh_Novemberkasan_Logotyp.png";

const NAV = [
  { to: "/tavlingsinformation", label: "Tävlingsinfo" },
  { to: "/for-forare", label: "Förare" },
  { to: "/publik", label: "Publik" },
  { to: "/dokument", label: "Dokument" },
  { to: "/partners", label: "Partners" },
  { to: "/historia", label: "Historia" },
];

export const Footer = () => {
  const { settings } = useData();
  const social = settings?.social || {};
  return (
    <footer className="relative border-t border-white/10 bg-[#08090B]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
        <div className="mb-10 border-b border-white/8 pb-10 grid gap-5 sm:grid-cols-2 sm:items-center" data-testid="footer-newsletter">
          <div>
            <h4 className="font-display text-2xl font-black uppercase text-white">Håll dig uppdaterad</h4>
            <p className="mt-1 text-sm text-white/55">Nyhetsbrev & uppdateringar inför Novemberkåsan 2026 – anmälan, startlistor och program.</p>
          </div>
          <NewsletterSignup source="footer" />
        </div>
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <img src={LOGO} alt="Novemberkåsan 2026" className="h-24 w-auto" />
            <p className="mt-4 text-sm text-white/55 leading-relaxed">
              Knivsta, Sverige<br />7–8 november 2026<br />
              En natt. En förare. En legend.
            </p>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-amber-500 mb-4">Navigation</h4>
            <ul className="space-y-2 text-sm">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-white/60 hover:text-amber-500 transition-colors">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-amber-500 mb-4">Kontakt</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-white/30" /> Knivsta, Sverige</li>
              <li>
                <span className="block font-mono text-[10px] uppercase tracking-widest text-white/35">Tävlingsledare</span>
                <span className="block text-white/80">Christer Eriksson</span>
                <a href="tel:+46702438640" className="hover:text-amber-500">070-243 86 40</a>
                <a href="mailto:cherik46@hotmail.com" className="block text-amber-500 hover:underline">cherik46@hotmail.com</a>
              </li>
              <li>
                <span className="block font-mono text-[10px] uppercase tracking-widest text-white/35">Presschef</span>
                <span className="block text-white/80">Sture Jonsson</span>
                <a href="tel:+46702436614" className="hover:text-amber-500">070-243 66 14</a>
                <a href="mailto:sture.jonsson2@gmail.com" className="block text-amber-500 hover:underline">sture.jonsson2@gmail.com</a>
              </li>
              <li className="pt-1">
                <span className="block font-mono text-[10px] uppercase tracking-widest text-white/35 mb-1">Samarbeten & Media</span>
                <a href="mailto:novemberkasanmedia@gmail.com" className="flex items-center gap-2 text-amber-500 hover:underline">
                  <Handshake className="w-4 h-4 text-white/40" /> novemberkasanmedia@gmail.com
                </a>
              </li>
              <li><Link to="/kontakt" className="text-amber-500 hover:underline">Alla kontaktpersoner →</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-amber-500 mb-4">Följ resan</h4>
            <div className="flex gap-3">
              {[[Instagram, social.instagram], [Facebook, social.facebook], [Youtube, social.youtube]].filter(([, url]) => url).map(([Icon, url], i) => (
                <a key={i} href={url} target="_blank" rel="noreferrer"
                  className="p-2.5 rounded-lg border border-white/10 text-white/60 hover:text-amber-500 hover:border-amber-500/50 transition-colors">
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs font-mono text-white/35">
          <span>© {new Date().getFullYear()} Novemberkåsan · Alla rättigheter förbehållna</span>
          <a href="https://enduroskola.se" target="_blank" rel="noreferrer"
            data-testid="footer-credit"
            className="group inline-flex items-center gap-2 rounded-full border border-white/10 px-3.5 py-1.5 text-white/45 hover:text-amber-500 hover:border-amber-500/40 transition-colors">
            <Wrench className="w-3.5 h-3.5 text-amber-500/70 group-hover:rotate-12 transition-transform" />
            <span>Byggd i leran av <span className="text-white/70 group-hover:text-amber-500">enduroskola.se</span></span>
          </a>
        </div>
      </div>
    </footer>
  );
};
